export interface Feature {
  icon: string;
  title: string;
  description: string;
}

const FEATURES: Feature[] = [
  {
    icon: '🤖',
    title: 'AI Writing Buddy',
    description:
      'Real-time feedback and encouragement as students write, helping them improve with every sentence.',
  },
  {
    icon: '🧩',
    title: 'Structured Writing Support',
    description:
      'Graphic organizers, planning blocks, and scaffolds that help students organize their thoughts.',
  },
  {
    icon: '📰',
    title: 'Classroom Newspapers',
    description:
      'Students become journalists — writing news stories, opinion pieces, book reviews, and more for their own class newspaper.',
  },
  {
    icon: '📝',
    title: 'Multiple Writing Formats',
    description:
      'From personal narratives to news articles, stories to opinion pieces — 10+ journalism templates and growing.',
  },
  {
    icon: '👩‍🏫',
    title: 'Teacher Dashboard',
    description:
      'Monitor the whole class at a glance, leave comments in real-time, and review student submissions.',
  },
  {
    icon: '🔒',
    title: 'Privacy by Design',
    description:
      'FERPA & COPPA compliant. Student PII is never sent to AI. Teachers control all AI interactions.',
  },
];

export default FEATURES;
